import { render } from "./NavItem.vue?vue&type=template&id=04d251a0"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"
script.render = render

export default script